module.exports = __webpack_public_path__ + "img/diqiu.87930a0a.png";